(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5474,5393],{

/***/ 34705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ form_Calendar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dates/initialize.js
var initialize = __webpack_require__(6063);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-dates/lib/css/_datepicker.css
var _datepicker = __webpack_require__(19498);
;// CONCATENATED MODULE: ./public/icons/icon-calendar-next.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconCalendarNext = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 8,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "m1 13 5.793-6.069L1.115 1",
  stroke: "#fff",
  strokeWidth: 1.2,
  strokeLinecap: "square"
})));

/* harmony default export */ var icon_calendar_next = (SvgIconCalendarNext);
;// CONCATENATED MODULE: ./public/icons/icon-calendar-previous.svg
var icon_calendar_previous_path;

function icon_calendar_previous_extends() { icon_calendar_previous_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_calendar_previous_extends.apply(this, arguments); }



const SvgIconCalendarPrevious = props => /*#__PURE__*/react.createElement("svg", icon_calendar_previous_extends({
  width: 8,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_calendar_previous_path || (icon_calendar_previous_path = /*#__PURE__*/react.createElement("path", {
  d: "M6.793 13 1 6.931 6.678 1",
  stroke: "#fff",
  strokeWidth: 1.2,
  strokeLinecap: "square"
})));

/* harmony default export */ var icon_calendar_previous = (SvgIconCalendarPrevious);
// EXTERNAL MODULE: ./components/elements/form/Calendar/styles.module.scss
var styles_module = __webpack_require__(33842);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./components/elements/DropdownField/index.js
var DropdownField = __webpack_require__(16971);
// EXTERNAL MODULE: ./components/elements/form/Radio/index.js
var Radio = __webpack_require__(87048);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./public/icons/icon-calendar.svg
var icon_calendar = __webpack_require__(48976);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(79697);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./providers/SearchContext.js
var SearchContext = __webpack_require__(65079);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/elements/form/Calendar/index.js








var DayPickerRangeController = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4634), __webpack_require__.e(5900)]).then(__webpack_require__.bind(__webpack_require__, 25900));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25900)
            ];
        }
    },
    ssr: false
});
var DayPickerSingleDateController = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4634), __webpack_require__.e(9368)]).then(__webpack_require__.bind(__webpack_require__, 99368));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99368)
            ];
        }
    },
    ssr: false
});
















var Calendar = function(_param) {
    var setStartDate = _param.setStartDate, setEndDate = _param.setEndDate, setOffsetDays = _param.setOffsetDays, numberOfMonths = _param.numberOfMonths, _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, _clearable = _param.clearable, clearable = _clearable === void 0 ? false : _clearable, _yearJump = _param.yearJump, yearJump = _yearJump === void 0 ? false : _yearJump, setDate = _param.setDate, _withOffset = _param.withOffset, withOffset = _withOffset === void 0 ? false : _withOffset, _blockedDates = _param.blockedDates, blockedDates = _blockedDates === void 0 ? false : _blockedDates, type = _param.type, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, // eslint-disable-next-line no-unused-vars
    date = _param.date, translations = _param.translations, minimumNights = _param.minimumNights, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "setStartDate",
        "setEndDate",
        "setOffsetDays",
        "numberOfMonths",
        "variant",
        "clearable",
        "yearJump",
        "setDate",
        "withOffset",
        "blockedDates",
        "type",
        "disabled",
        "date",
        "translations",
        "minimumNights",
        "className"
    ]);
    var isSmallMobile = (0,ResponsiveContext/* useResponsive */.F)().isSmallMobile;
    var router = (0,next_router.useRouter)();
    var ref = (0,SearchContext/* useSearchContext */.AB)(), offsetable = ref.offsetable, search = ref.search;
    var ref1 = (0,react.useState)("startDate"), focusedInput = ref1[0], setFocusedInput = ref1[1];
    var ref2 = (0,react.useState)(moment_default()().utc().startOf("day")), initialMonth = ref2[0], setInitialMonth = ref2[1];
    var ref3 = (0,react.useState)(moment_default()().utc().startOf("day")), singleCalendarMonth = ref3[0], setSingleCalendarMonth = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)(1), opacity = ref5[0], setOpacity = ref5[1];
    var ref6 = (0,react.useState)(false), checked = ref6[0], setChecked = ref6[1];
    var ref7 = (0,react.useState)(offsetable), offset = ref7[0], setOffset = ref7[1];
    var returnNearestDayUp = function() {
        var offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        var nearestDate;
        blockedDates && blockedDates.map(function(date) {
            var diff = date.diff(search.startDate, "days");
            if (diff > offset && !date.isSame(search.startDate, "day")) {
                if (nearestDate) {
                    if (date.diff(nearestDate, "days") < 0) {
                        nearestDate = date;
                    }
                } else {
                    nearestDate = date;
                }
            }
        });
        return nearestDate;
    };
    var returnNearestDayDown = function() {
        var offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        var nearestDate;
        blockedDates && blockedDates.map(function(date) {
            var diff = date.diff(search.endDate, "days");
            if (diff < offset) {
                if (nearestDate) {
                    if (date.diff(nearestDate, "days") > 0) {
                        nearestDate = date;
                    }
                } else {
                    nearestDate = date;
                }
            }
        });
        return nearestDate;
    };
    var fireRefresh = function() {
        setOpacity(0);
        setTimeout(function() {
            return setLoading(true);
        }, 150);
        setTimeout(function() {
            return setLoading(false);
        }, 200);
        setTimeout(function() {
            return setOpacity(1);
        }, 900);
    };
    (0,react.useEffect)(function() {
        fireRefresh();
    }, [
        blockedDates
    ]);
    var defaultProps = {
        navPrev: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_calendar_previous, {
            onClick: function() {
                if (yearJump) {
                    setOpacity(0);
                    setTimeout(function() {
                        return setOpacity(1);
                    }, 900);
                }
            }
        }),
        navNext: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_calendar_next, {
            onClick: function() {
                if (yearJump) {
                    setOpacity(0);
                    setTimeout(function() {
                        return setOpacity(1);
                    }, 900);
                }
            }
        }),
        daySize: isSmallMobile ? 30 : 35,
        numberOfMonths: numberOfMonths ? numberOfMonths : isSmallMobile ? 1 : 2
    };
    var returnYears = function() {
        var years = [];
        for(var i = Number(moment_default()().utc().format("YYYY")); i <= moment_default()().utc().add(2, "years").format("YYYY"); i++){
            years.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                variant: [
                    "underline"
                ],
                onChange: function(e) {
                    var currentMonth = initialMonth.clone();
                    var monthDiff = currentMonth.format("M") - 1;
                    setChecked(Number(e.target.value));
                    setDate(Number(e.target.value));
                    setInitialMonth(moment_default()(e.target.value).utc().add(monthDiff, "months"));
                    fireRefresh();
                },
                name: "years",
                label: i,
                checked: checked === i,
                value: i,
                children: i
            }, "Radio-".concat(i)));
        }
        return years;
    };
    (0,react.useEffect)(function() {
        if (props.startDate === null) {
            setFocusedInput("startDate");
        }
        if (props.startDate && props.endDate === null) {
            setFocusedInput("endDate");
        }
        if (props.startDate && props.endDate) {
            setFocusedInput("startDate");
        }
    }, [
        props.startDate,
        props.endDate
    ]);
    var handleDatesChange = function(startDate, endDate) {
        // Ensure dates are set to start of day
        var normalizedStartDate = startDate ? moment_default()(startDate).utc().startOf("day") : null;
        var normalizedEndDate = endDate ? moment_default()(endDate).utc().startOf("day") : null;
        // Functionality that focuses start date / end date
        // It will always have first click start date, second click end date
        if (props.startDate === null && props.endDate === null) {
            setStartDate(normalizedStartDate);
            setTimeout(function() {
                return setFocusedInput("endDate");
            }, 10);
        }
        if (props.startDate === null && props.endDate) {
            setStartDate(normalizedStartDate);
            setTimeout(function() {
                return setFocusedInput("endDate");
            }, 10);
        }
        if (props.startDate && props.endDate === null) {
            setEndDate(normalizedEndDate);
            setTimeout(function() {
                return setFocusedInput("startDate");
            }, 10);
        }
        if (props.startDate && props.endDate) {
            setEndDate(null);
            setStartDate(normalizedStartDate);
            setTimeout(function() {
                return setFocusedInput("endDate");
            }, 10);
        }
        if (normalizedStartDate && (normalizedStartDate === null || normalizedStartDate === void 0 ? void 0 : normalizedStartDate.isBefore(props.startDate, "day")) || (normalizedStartDate === null || normalizedStartDate === void 0 ? void 0 : normalizedStartDate.isAfter(props.endDate, "day"))) {
            setEndDate(null);
            setStartDate(normalizedStartDate);
            setTimeout(function() {
                return setFocusedInput("endDate");
            }, 10);
        }
    };
    var onFocusChange = function(focusedInput) {
        setFocusedInput(focusedInput);
    };
    var rangeControllerIsOutside = function(day) {
        if (blockedDates && !(0,isEmpty/* default */.Z)(blockedDates)) {
            var BlockedDate = blockedDates.find(function(item) {
                return item.format("YYYY-MM-DD") === day.format("YYYY-MM-DD");
            });
            if (props.startDate && focusedInput === "endDate") {
                var NextDay = day.clone().subtract(1, "day");
                var EndBlocked = blockedDates && blockedDates.find(function(item) {
                    return item.format("YYYY-MM-DD") === NextDay.format("YYYY-MM-DD");
                });
                var nearestDate = returnNearestDayUp(-1);
                var booked = EndBlocked === null || EndBlocked === void 0 ? void 0 : EndBlocked.clone();
                if (nearestDate) {
                    return (day === null || day === void 0 ? void 0 : day.isAfter(nearestDate, "day")) + (day === null || day === void 0 ? void 0 : day.isSame(booked === null || booked === void 0 ? void 0 : booked.add(1, "day"), "day")) + (day === null || day === void 0 ? void 0 : day.isBefore(moment_default()().utc(), "day"));
                }
            }
            if (props.endDate && props.startDate === null && focusedInput === "startDate") {
                var nearestDate1 = returnNearestDayDown();
                if (nearestDate1) {
                    return day.isBefore(nearestDate1, "day") + day.isSame(BlockedDate, "day");
                }
            }
            if (day.isSame(moment_default()().utc())) {
                return 0;
            }
            return day.isSame(BlockedDate, "day") + day.isBefore(moment_default()().utc(), "day");
        }
        return day.isBefore(moment_default()().utc(), "day");
    };
    var onPrevMonthClick = function(month) {
        if (setEndDate) {
            setInitialMonth(month);
            setChecked(Number(month.format("YYYY")));
            setDate(Number(month.format("YYYY")));
            setTimeout(function() {
                return setLoading(true);
            }, 150);
            setTimeout(function() {
                return setLoading(false);
            }, 200);
        }
    };
    var onNextMonthClick = function(month) {
        if (setEndDate) {
            setInitialMonth(month);
            setChecked(Number(month.format("YYYY")));
            setDate(Number(month.format("YYYY")));
            setTimeout(function() {
                return setLoading(true);
            }, 150);
            setTimeout(function() {
                return setLoading(false);
            }, 200);
        }
    };
    (0,react.useEffect)(function() {
        if (type === "startDate" || type === "endDate") {
            if (search.startDate) {
                setSingleCalendarMonth(moment_default()(search.startDate).utc().startOf("day"));
                setLoading(true);
                setTimeout(function() {
                    return setLoading(false);
                }, 200);
            }
            if (search.endDate) {
                setSingleCalendarMonth(moment_default()(search.endDate).utc().startOf("day"));
                setLoading(true);
                setTimeout(function() {
                    return setLoading(false);
                }, 200);
            }
        }
    }, [
        search.startDate,
        search.endDate
    ]);
    var dayPickerOutsideRange = function(day) {
        var defaultBlocked = day.isBefore(moment_default()().utc(), "day");
        if (blockedDates && !(0,isEmpty/* default */.Z)(blockedDates)) {
            if (type === "startDate") {
                var BlockedDate = blockedDates && blockedDates.find(function(item) {
                    return item.format("YYYY-MM-DD") === day.format("YYYY-MM-DD");
                });
                if (search.endDate) {
                    // checks so that you can't select a date that overlaps range of blocked dates
                    return defaultBlocked + (day === null || day === void 0 ? void 0 : day.isSame(BlockedDate, "day")) + (day === null || day === void 0 ? void 0 : day.isSame(search.endDate, "day")) + (day === null || day === void 0 ? void 0 : day.isAfter(moment_default()().utc().add(3, "years")));
                }
                if (day.isSame(moment_default()().utc(), "day") && !BlockedDate) {
                    return 0;
                }
                return defaultBlocked + (day === null || day === void 0 ? void 0 : day.isSame(BlockedDate, "day")) + (day === null || day === void 0 ? void 0 : day.isAfter(moment_default()().utc().add(3, "years")));
            }
            if (type === "endDate") {
                var NextDay = day.clone().subtract(1, "day");
                var BlockedDate1 = blockedDates && blockedDates.find(function(item) {
                    return item.format("YYYY-MM-DD") === NextDay.format("YYYY-MM-DD");
                });
                var booked = BlockedDate1 === null || BlockedDate1 === void 0 ? void 0 : BlockedDate1.clone();
                if (search.startDate) {
                    // checks so that you can't select a date that overlaps range of blocked dates
                    var nearestDate = returnNearestDayUp();
                    if (nearestDate) {
                        return defaultBlocked + (day === null || day === void 0 ? void 0 : day.isSame(booked === null || booked === void 0 ? void 0 : booked.add(1, "day"), "day")) + (day === null || day === void 0 ? void 0 : day.isSame(search.startDate, "day")) + (day === null || day === void 0 ? void 0 : day.isAfter(moment_default()().utc().add(3, "years")));
                    }
                    return defaultBlocked + BlockedDate1 + (day === null || day === void 0 ? void 0 : day.isSame(search.startDate, "day")) + (day === null || day === void 0 ? void 0 : day.isAfter(moment_default()().utc().add(3, "years")));
                }
                return defaultBlocked + (day === null || day === void 0 ? void 0 : day.isSame(booked === null || booked === void 0 ? void 0 : booked.add(1, "day"), "day")) + (day === null || day === void 0 ? void 0 : day.isAfter(moment_default()().utc().add(3, "years")));
            }
        }
        return defaultBlocked;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(className, (0,withModifiers/* withModifiers */.i)("calendar", (0,_to_consumable_array/* default */.Z)(variant).concat([
            disabled && "disabled"
        ]), (styles_module_default()))),
        children: setEndDate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        opacity: opacity
                    },
                    className: (styles_module_default()).calendar__wrapper,
                    children: !loading ? yearJump ? /*#__PURE__*/ (0,react.createElement)(DayPickerRangeController, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultProps), {
                        disabled: disabled,
                        onDatesChange: function(param) {
                            var startDate = param.startDate, endDate = param.endDate;
                            handleDatesChange(startDate, endDate);
                        },
                        key: initialMonth.format("YYYY-MM") + "-" + (blockedDates ? blockedDates.map(function(d) {
                            return d.format("YYYY-MM-DD");
                        }).join(",") : ""),
                        isOutsideRange: function(day) {
                            return rangeControllerIsOutside(day);
                        },
                        focusedInput: focusedInput,
                        onFocusChange: onFocusChange,
                        minDate: moment_default()().utc(),
                        onPrevMonthClick: function(month) {
                            return onPrevMonthClick(month);
                        },
                        onNextMonthClick: function(month) {
                            return onNextMonthClick(month);
                        },
                        initialVisibleMonth: function() {
                            return initialMonth;
                        },
                        maxDate: moment_default()().utc().add(3, "years"),
                        minimumNights: blockedDates && (returnNearestDayUp() === undefined || props.startDate && returnNearestDayUp() && returnNearestDayUp().diff(props.startDate, "days") > minimumNights) && minimumNights || 0
                    }), props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,react.createElement)(DayPickerRangeController, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultProps), {
                            disabled: disabled,
                            key: initialMonth.format("YYYY-MM") + "-" + (blockedDates ? blockedDates.map(function(d) {
                                return d.format("YYYY-MM-DD");
                            }).join(",") : ""),
                            onDatesChange: function(param) {
                                var startDate = param.startDate, endDate = param.endDate;
                                handleDatesChange(startDate, endDate);
                            },
                            maxDate: moment_default()().utc().add(3, "years"),
                            isOutsideRange: function(day) {
                                return rangeControllerIsOutside(day);
                            },
                            focusedInput: focusedInput,
                            onFocusChange: onFocusChange,
                            minDate: moment_default()().utc()
                        }), props))
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                }),
                withOffset && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).calendar__offsets,
                    children: Array.from({
                        length: 4
                    }).map(function(currentElement, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                            value: index,
                            label: index === 0 ? translations === null || translations === void 0 ? void 0 : translations.exactDates[router.locale] : "\xb1 ".concat(index, " ").concat(!isSmallMobile ? translations === null || translations === void 0 ? void 0 : translations.days[router.locale] : ""),
                            onChange: function(e) {
                                setOffset(Number(e.target.value));
                                setOffsetDays(Number(e.target.value));
                            },
                            name: "offset",
                            checked: index === offset,
                            variant: [
                                "inline",
                                "boxed"
                            ]
                        }, "Radio-".concat(currentElement, "-").concat(index));
                    })
                }),
                (clearable || yearJump) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).calendar__footer,
                    children: [
                        clearable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                            type: "button",
                            onClick: function() {
                                setStartDate(null);
                                setEndDate(null);
                                setFocusedInput("startDate");
                            },
                            disabled: props.startDate === null && props.endDate === null,
                            variant: [
                                "label",
                                "gray"
                            ],
                            arrow: false,
                            children: isSmallMobile ? translations === null || translations === void 0 ? void 0 : translations.clear[router.locale] : translations === null || translations === void 0 ? void 0 : translations.clearDates[router.locale]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).calendar__select,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).calendar__label,
                                    children: translations.skip[router.locale]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownField/* default */.Z, {
                                    variant: [
                                        "top",
                                        "dropdown",
                                        "accent",
                                        "p-xs"
                                    ],
                                    footer: false,
                                    name: "yearChange",
                                    width: 9.4,
                                    disabled: disabled,
                                    prependIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_calendar/* default */.Z, {}),
                                    value: initialMonth.format("YYYY"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: returnYears()
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                opacity: opacity,
                minHeight: "250px"
            },
            className: (0,withModifiers/* withModifiers */.i)("calendar__single", [
                disabled && "disabled"
            ], (styles_module_default())),
            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DayPickerSingleDateController, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultProps), {
                transitionDuration: 0,
                onDateChange: function(date) {
                    setStartDate(date);
                },
                initialVisibleMonth: function() {
                    return singleCalendarMonth;
                },
                date: props.startDate,
                focused: true,
                isOutsideRange: function(day) {
                    return dayPickerOutsideRange(day);
                }
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DayPickerSingleDateController, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultProps), {
                    transitionDuration: 0,
                    onDateChange: function(date) {
                        setStartDate(date);
                    },
                    initialVisibleMonth: function() {
                        return singleCalendarMonth;
                    },
                    date: props.startDate,
                    focused: true,
                    isOutsideRange: function(day) {
                        return dayPickerOutsideRange(day);
                    }
                }))
            })
        })
    });
};
var withCalendar = function(Component) {
    return function Wrapper(props) {
        var ref = (0,react.useState)(0), date = ref[0], setDate = ref[1];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({
            date: date,
            setDate: setDate
        }, props));
    };
};
/* harmony default export */ var form_Calendar = (withCalendar(Calendar));


/***/ }),

/***/ 33842:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"calendar":"styles_calendar__z0bFn","calendar__footer":"styles_calendar__footer__WWWcx","calendar__select":"styles_calendar__select__bLNvB","calendar__label":"styles_calendar__label__VOuYY","calendar__offsets":"styles_calendar__offsets__uRlsb","calendar__wrapper":"styles_calendar__wrapper__U347A","calendar--disabled":"styles_calendar--disabled__sooj4","calendar--large":"styles_calendar--large__inLSv","calendar__single":"styles_calendar__single__Vx64K","calendar__single--disabled":"styles_calendar__single--disabled__Aqqvd","calendar--dark":"styles_calendar--dark__YXKsx"};

/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);